import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MarketingHeaderComponent } from './shared/components/marketing-header/marketing-header.component';
import { AppHeaderComponent } from './shared/components/app-header/app-header.component';
import { FooterComponent } from './shared/components/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    MarketingHeaderComponent,
    AppHeaderComponent,
    FooterComponent
  ],
  template: `
    <!-- Marketing Header for Landing Page -->
    @if (isLandingPage()) {
      <app-marketing-header />
    } @else {
      <app-app-header />
    }
    
    <main class="main-content" [class.with-app-header]="!isLandingPage()">
      <router-outlet />
    </main>
    
    <app-footer />
  `,
  styles: [`
    .main-content {
      min-height: 100vh;
    }
    
    .main-content.with-app-header {
      padding-top: 70px; /* Account for fixed app header */
    }
  `]
})
export class App {
  private router = inject(Router);

  isLandingPage = signal(true);

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const url = event.urlAfterRedirects;
      this.isLandingPage.set(url === '/' || url === '');
    });

    // Set initial state
    this.isLandingPage.set(this.router.url === '/' || this.router.url === '');
  }
}
